<h1 class="page-title">Hírek</h1>

<div *ngFor="let article of articles" class="article">
  <h6><a [routerLink]="['/tartalmak/hirek', article.id]">{{article.title}}</a></h6>
  <p>{{article.short}}</p>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/article-list/article-list.component.html